// Runs before React renders (src/index.js). When nobody is signed in and the page is a sign-in
// page for the airline remembered on this device, its colours and favicon are applied
// immediately — so returning airline staff never see the Vamos colours flash first.
import { applyBrand } from './applyBrand'
import { loadLoginBrand } from './brandStorage'

export function prePaintBrand(location = window.location, storage = window.localStorage) {
  try {
    if (JSON.parse(storage.getItem('auth') || 'null')) return null
    const brand = loadLoginBrand(storage)
    if (!brand) return null
    const path = location.pathname.replace(/\/+$/, '') || '/'
    const lastSegment = path.split('/').pop().toLowerCase()
    // Only pages that carry that airline's code (/ and /login are always Vamos).
    if (path !== '/' && path !== '/login' && lastSegment === brand.code) {
      applyBrand(brand)
      return brand
    }
  } catch (e) {
    // storage unavailable — the page simply renders without pre-applied colours
  }
  return null
}
